import * as Yup from "yup";

export const overduePaymentSchema = Yup.object({

    gender: Yup.string().required("Please Select Payment Type"),
    customerName: Yup.string().required("Please Select Customer Name"),

});